"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetResizeIcon = void 0;
const WidgetResizeIcon_1 = __importDefault(require("./WidgetResizeIcon"));
exports.WidgetResizeIcon = WidgetResizeIcon_1.default;
exports.default = WidgetResizeIcon_1.default;
